import moment from 'moment';
import { orderBy } from 'natural-orderby';
import { useReducer, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { config } from '../../config/index';

import ToastUtil from '../../components/ToastNotification/ToastUtil';
import { GET, newFetch } from '../../helpers/fetch';
import ManpowerWeb from '../../screens/App/';
import {
  CLIENT_FILTER,
  LOGIN,
  LOGOUT,
  SET_ACCESS,
  SET_CLIENT_OPTIONS,
  SET_SITE_OPTIONS,
  SET_USER,
  SET_USER_TYPE,
  SITE_FILTER,
} from './actions';
import AppContext from './contexts';
import AppReducer from './reducers';

const { API_URL } = config;

const initialState = {
  // isLoggedIn:
  //   localStorage.getItem("token") && (localStorage.getItem("loginDate") < localStorage.getItem("expiryDate"))
  //     ? true
  //     : false,
  isLoggedIn: localStorage.getItem('token') ? true : false,
  isLoading: false,
  type: localStorage.getItem('type') ? localStorage.getItem('type') : false,
  user: localStorage.getItem('user')
    ? JSON.parse(localStorage.getItem('user'))
    : false,
  selectedClientID: localStorage.getItem('client')
    ? localStorage.getItem('client')
    : null,
  selectedSiteID: localStorage.getItem('site')
    ? localStorage.getItem('site')
    : null,
  client_options: null,
  site_options: null,
};

const AppStore = () => {
  const [state, dispatch] = useReducer(AppReducer, initialState);
  const [access, setAccess] = useState([]);

  const loginHandler = async (type, email, password, event) => {
    event.preventDefault();

    let url = `${API_URL}/${type}/login`;
    try {
      let response = await fetch(url, {
        method: 'POST',
        mode: 'cors',
        withCredentials: false,
        body: JSON.stringify({ email, password }),
        headers: {
          'Access-Control-Allow-Origin': '*',
          Accept: 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
        },
      });

      let data = await response.json();

      if (!response.ok) {
        //AlertService.error("Error", data.message);
        ToastUtil.error(data.message);
      } else {
        if (data.success) {
          let loginDate = moment().valueOf();
          // let expiryDate = moment().add(tokenExpiry, 'hours').valueOf()
          await localStorage.setItem('access', JSON.stringify(data.access));
          await localStorage.setItem('loginDate', loginDate);
          setAccess(data.access);
          // await localStorage.setItem('expiryDate', expiryDate)

          data.access &&
            (await dispatch({ type: SET_ACCESS, payload: data.access }));
          data.token && (await localStorage.setItem('token', data.token));
          data.type && (await localStorage.setItem('type', data.type));
          data.type &&
            (await dispatch({ type: SET_USER_TYPE, payload: data.type }));
          data.user &&
            (await localStorage.setItem('user', JSON.stringify(data.user)));
          data.user && (await dispatch({ type: SET_USER, payload: data.user }));

          fetchClientSiteOptions();

          if (data.type && data.user) {
            await dispatch({ type: LOGIN });
          }
        } else {
          ToastUtil.error(data.message);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const logoutHandler = () => {
    // localStorage.getItem("token") && localStorage.clear();
    localStorage.clear();
    dispatch({ type: LOGOUT });
    // return <Redirect to="/login" />
  };

  const checkTokenHandler = async () => {
    let token = localStorage.getItem('token');

    if (token) {
      let url = `${API_URL}/checkToken`;

      try {
        let response = await fetch(url, {
          mode: 'cors',
          method: 'GET',
          withCredentials: true,
          headers: {
            Authorization: token,
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json; charset=utf-8',
          },
        });

        let responseData = await response.json();

        if (!responseData.success) {
          logoutHandler();
          return <Redirect to="/login" />;
        }
      } catch (error) {
        logoutHandler();
        return <Redirect to="/login" />;
      }
    } else {
      logoutHandler();
      return <Redirect to="/login" />;
    }
  };

  const fetchClientSiteOptions = async () => {
    try {
      let api_path = `/client/options`;
      let response = await newFetch(GET, api_path);

      if (response.success) {
        const clientSiteOptions = orderBy(
          response.data.filter((client) => client.active === true),
          [(client) => client.name]
        ).map((client) => ({
          ...client,
          sites: orderBy(
            (client.sites || []).filter((site) => site.active === true),
            [(site) => site.name]
          ),
        }));

        localStorage.setItem(
          'clientSiteOptions',
          JSON.stringify(clientSiteOptions)
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchClientsOptions = async (type) => {
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      let api_path = `/client`;
      let response = await newFetch(GET, api_path);
      let clientsData;

      if (response.success) {
        if (type === 'superadmin') {
          clientsData = orderBy(
            response.data.filter((client) => client.active === true),
            [(client) => client.name]
          );
        } else if (type === 'admin' || type === 'client') {
          clientsData = orderBy(
            response.data.filter(
              (client) =>
                client.active === true &&
                user.client_admins.some(
                  (admin) => admin.client_id === client.id
                )
            ),
            [(client) => client.name]
          );
        } else {
          clientsData = null;
        }

        dispatch({
          type: SET_CLIENT_OPTIONS,
          payload: clientsData,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchSiteOptions = async (type) => {
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      let api_path = `/sites`;
      let response = await newFetch(GET, api_path);
      let siteData;

      if (response.success) {
        siteData = orderBy(
          response.data.filter((site) => site.active === true),
          [(site) => site.name]
        );

        dispatch({
          type: SET_SITE_OPTIONS,
          payload: siteData,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const clientFilterHandler = (id) => {
    dispatch({
      type: CLIENT_FILTER,
      payload: { id },
    });
  };

  const siteFilterHandler = (id) => {
    dispatch({
      type: SITE_FILTER,
      payload: { id },
    });
  };

  return (
    <AppContext.Provider
      value={{
        isLoggedIn: state.isLoggedIn,
        isLoading: state.isLoading,
        loginHandler,
        logoutHandler,
        user: state.user,
        type: state.type,
        checkTokenHandler,
        access: state.access,
        selectedClientID: state.selectedClientID,
        clientFilterHandler,
        selectedSiteID: state.selectedSiteID,
        siteFilterHandler,
        client_options: state.client_options,
        fetchClientsOptions,
        site_options: state.site_options,
        fetchSiteOptions,
      }}
    >
      <ManpowerWeb access={access} />
    </AppContext.Provider>
  );
};

export default AppStore;
